/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type CategoryDataProps = {
  formData: AbstractCase | Record<string, any>;
  translate: Function;
};

const CategoryData = ({ formData, translate }: CategoryDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Ihr Anliegen</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"gender"} />
        Suche Informationen zu
      </Grid>
      <Grid size={12}>
        {translate("generalCategory." + formData.generalCategory, formData)}
      </Grid>
      {["both", "death"].includes(formData.generalCategory) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} />
            Todesfall aktuell?
          </Grid>
          <Grid size={12}>
            {translate("deathCategory." + formData.deathCategory, formData)}
          </Grid>
        </>
      )}
      {["inheritance", "both"].includes(formData.generalCategory) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} />
            Erbe oder Vererben?
          </Grid>
          <Grid size={12}>
            {translate("inheritanceCategory." + formData.inheritanceCategory, formData)}
          </Grid>
        </>
      )}
    </>
  );
};

export default CategoryData;
